export default "__VITE_ASSET__CpCyUldO__"